const en = {
  nav: {
    home: 'Home',
    services: 'Services',
    portfolio: 'Portfolio',
    reviews: 'Reviews',
    faq: 'FAQ',
    process: 'Process',
    about: 'About',
    contact: 'Contact',
    book: 'Book Now',
    bookLong: 'Book on WhatsApp',
    call: 'Call',
    openMenu: 'Open menu',
    closeMenu: 'Close menu',
    main: 'Main navigation',
    allServices: 'All services',
    allWork: 'All work',
    languageLabel: 'Change language',
  },
  promo: {
    text: 'Fall celebration season —',
    highlight: '15% off',
    rest: 'full flower & balloon packages booked before October 30.',
    cta: 'Claim it',
    dismiss: 'Dismiss promotion',
  },
  kinds: {
    flowers: 'Flowers',
    balloons: 'Balloons',
    both: 'Flowers + Balloons',
  },
  fab: {
    whatsapp: 'Chat with us on WhatsApp',
    reply: 'Replies in ~15 min',
    call: 'Call us',
  },
  cta: {
    title: 'Let’s plan your celebration',
    text: 'Send your date, venue and colors. We reply with a design idea and a fixed price — usually the same day.',
    primary: 'Book Flowers & Balloons',
    call: 'Call (240) 413-8201',
  },
  footer: {
    blurb:
      'Flores con Aroma de Café — florist and event decorator in Jessup, Maryland. Wedding flowers, quinceañera decorations, custom arrangements and professional balloon decorations. Serving Howard, Anne Arundel & Prince George’s County. Same-day service available. Call (240) 413-8201.',
    quickLinks: 'Quick links',
    services: 'Services',
    contact: 'Contact',
    social: 'Follow us',
    hours: 'Mon – Sat 9 AM – 7 PM · Sun by appointment',
    area: 'Jessup, Columbia, Laurel, Elkridge & surrounding areas',
    directions: 'Get directions',
    rights: 'All rights reserved.',
  },
  placeholder: 'Photo coming soon',
  learnMore: 'Learn more',
  starsLabel: 'out of 5 stars',
  seo: {
    home: {
      title: 'Flores con Aroma de Café | Flowers & Balloons Jessup MD | Wedding Decorator',
      description:
        'Flores con Aroma de Café — professional florist and balloon decorator in Jessup, MD. Wedding flowers, quinceañera decorations, custom arrangements & balloon installations. 5.0★ rated. Same-day service. Call (240) 413-8201',
    },
    services: {
      title: 'Floral Design & Balloon Decorations | Jessup, Maryland | Events & Weddings',
      description:
        'Wedding flowers, balloon decorations, event centerpieces & custom arrangements. Professional floral design & balloon artistry in Jessup, Maryland. Expert event styling. Same-day service available.',
    },
    portfolio: {
      title: 'Wedding Flowers, Balloon Decorations & Events | Flores con Aroma de Café',
      description:
        'See real weddings, quinceañeras, themed balloon installations and floral centerpieces by Flores con Aroma de Café in Jessup, Maryland.',
    },
    reviews: {
      title: 'Reviews | Florist & Balloon Decorator Jessup MD | 5.0★',
      description:
        'Read what clients say about our wedding flowers, balloon arches and quinceañera decorations in Howard, Anne Arundel & Prince George’s County.',
    },
    faq: {
      title: 'FAQ | Flowers & Balloon Decorations | Flores con Aroma de Café',
      description:
        'Delivery area, booking timelines, balloon longevity, combining flowers and balloons, rush orders and pricing — answered.',
    },
    process: {
      title: 'How It Works | Event Flowers & Balloons in Jessup, Maryland',
      description:
        'Consultation, design proposal, confirmation and on-site setup — how we plan your flower and balloon decorations.',
    },
    about: {
      title: 'About Us | Bilingual Florist & Balloon Artist in Jessup, MD',
      description:
        'Meet Flores con Aroma de Café, a bilingual floral and balloon decoration studio serving Jessup, Columbia, Laurel and Elkridge, Maryland.',
    },
    contact: {
      title: 'Contact | Book Flowers & Balloons in Jessup, MD | (240) 413-8201',
      description:
        'Request a quote for wedding flowers, balloon arches and event decorations. Call or WhatsApp (240) 413-8201. Mon–Sat 9 AM–7 PM.',
    },
    detail: {
      suffix: 'Jessup, MD | Flores con Aroma de Café',
    },
  },
}

const es: typeof en = {
  nav: {
    home: 'Inicio',
    services: 'Servicios',
    portfolio: 'Portafolio',
    reviews: 'Reseñas',
    faq: 'Preguntas',
    process: 'Proceso',
    about: 'Nosotros',
    contact: 'Contacto',
    book: 'Reservar',
    bookLong: 'Reservar por WhatsApp',
    call: 'Llamar',
    openMenu: 'Abrir menú',
    closeMenu: 'Cerrar menú',
    main: 'Navegación principal',
    allServices: 'Todos los servicios',
    allWork: 'Todos los trabajos',
    languageLabel: 'Cambiar idioma',
  },
  promo: {
    text: 'Temporada de celebraciones de otoño —',
    highlight: '15% de descuento',
    rest: 'en paquetes completos de flores y globos reservados antes del 30 de octubre.',
    cta: 'Aprovechar',
    dismiss: 'Cerrar promoción',
  },
  kinds: {
    flowers: 'Flores',
    balloons: 'Globos',
    both: 'Flores + Globos',
  },
  fab: {
    whatsapp: 'Escríbanos por WhatsApp',
    reply: 'Respuesta en ~15 min',
    call: 'Llámenos',
  },
  cta: {
    title: 'Planeemos su celebración',
    text: 'Envíenos la fecha, el lugar y sus colores. Le respondemos con una idea de diseño y un precio fijo — normalmente el mismo día.',
    primary: 'Reservar Flores y Globos',
    call: 'Llamar (240) 413-8201',
  },
  footer: {
    blurb:
      'Flores con Aroma de Café — floristería y decoradora de eventos en Jessup, Maryland. Flores de boda, decoraciones de quinceañera, arreglos personalizados y decoraciones de globos profesionales. Servimos los condados de Howard, Anne Arundel y Prince George’s. Servicio el mismo día disponible.',
    quickLinks: 'Enlaces',
    services: 'Servicios',
    contact: 'Contacto',
    social: 'Síganos',
    hours: 'Lun – Sáb 9 AM – 7 PM · Dom con cita',
    area: 'Jessup, Columbia, Laurel, Elkridge y alrededores',
    directions: 'Cómo llegar',
    rights: 'Todos los derechos reservados.',
  },
  placeholder: 'Foto próximamente',
  learnMore: 'Ver más',
  starsLabel: 'de 5 estrellas',
  seo: {
    home: {
      title: 'Flores con Aroma de Café | Flores y Globos Jessup MD',
      description:
        'Floristería y decoración con globos en Jessup, MD. Flores de boda, decoraciones de quinceañera, arreglos personalizados e instalaciones de globos. 5.0★. Servicio el mismo día. Llame al (240) 413-8201',
    },
    services: {
      title: 'Diseño Floral y Decoraciones de Globos | Jessup, Maryland',
      description:
        'Flores de boda, decoraciones de globos, centros de mesa y arreglos florales personalizados en Jessup, Maryland. Servicio de floristería el mismo día.',
    },
    portfolio: {
      title: 'Flores de Boda, Globos y Eventos | Flores con Aroma de Café',
      description:
        'Vea bodas, quinceañeras, instalaciones temáticas de globos y centros de mesa reales de Flores con Aroma de Café en Jessup, Maryland.',
    },
    reviews: {
      title: 'Reseñas | Floristería y Globos en Jessup MD | 5.0★',
      description:
        'Lea lo que dicen nuestros clientes sobre flores de boda, arcos de globos y decoraciones de quinceañera en Maryland.',
    },
    faq: {
      title: 'Preguntas Frecuentes | Flores y Globos | Flores con Aroma de Café',
      description:
        'Área de entrega, tiempos de reserva, duración de los globos, combinaciones de flores y globos, pedidos urgentes y precios.',
    },
    process: {
      title: 'Cómo Funciona | Flores y Globos para Eventos en Jessup, Maryland',
      description:
        'Consulta, propuesta de diseño, confirmación e instalación — así planeamos las flores y globos de su evento.',
    },
    about: {
      title: 'Nosotros | Floristería Bilingüe y Decoración de Globos en Jessup, MD',
      description:
        'Conozca Flores con Aroma de Café, estudio bilingüe de decoración floral y de globos en Jessup, Columbia, Laurel y Elkridge, Maryland.',
    },
    contact: {
      title: 'Contacto | Reserve Flores y Globos en Jessup, MD | (240) 413-8201',
      description:
        'Solicite una cotización para flores de boda, arcos de globos y decoración de eventos. Llame o escriba por WhatsApp al (240) 413-8201.',
    },
    detail: {
      suffix: 'Jessup, MD | Flores con Aroma de Café',
    },
  },
}

export const common = { en, es }
